<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter1"><b>SONG OF SELF-PITY</b> </p>
<p class="textcenterwithspace1">The song of self-pity is written in the soul.</p>
<p class="textcenter">Crying for the worth we need—the worth that makes us whole.</p>
<p class="textcenterwithspace1">Rage in the evening</p>
<p class="textcenter">For the power we don’t have.</p>
<p class="textcenter">Tears in the morning</p>
<p class="textcenter">For praise we never gave.</p>
<p class="textcenterwithspace1">Little birds atwitter</p>
<p class="textcenter">So happy to be alive.</p>
<p class="textcenter">Puppy dogs a-scratchin’</p>
<p class="textcenter">To the cosmic jive.</p>
<p class="textcenterwithspace1">Pride masks the shame,</p>
<p class="textcenter">The ache in our hearts.</p>
<p class="textcenter">Are we human refuse,</p>
<p class="textcenter">Losers from the start?</p>
<p class="textcenterwithspace1">Every moment of sorrow</p>
<p class="textcenter">Little birds sing with glee.</p>
<p class="textcenter">Should we waste the gift of life</p>
<p class="textcenter">Given to us all for free?</p>
<p class="textcenterwithspace1">We are the poor</p>
<p class="textcenter">So sadly on the dole,</p>
<p class="textcenter">Blinded to a better life—</p>
<p class="textcenter">Need we pay this toll?</p>
<p class="textcenterwithspace1">The song of self-pity is written in the soul.</p>
<p class="textcenter">Crying for the worth we need—we need to make us whole.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface_b.vue?3e87b16c